var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJapaneseFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.27,
    height: 18.27,
    viewBox: "0 0 18.27 18.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_835",
    "data-name": "Ellipse 835",
    cx: 9.135,
    cy: 9.135,
    r: 9.135,
    transform: "translate(869 572)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25726",
    "data-name": "Mask Group 25726",
    transform: "translate(-869 -572)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_838",
    "data-name": "Ellipse 838",
    cx: 5.135,
    cy: 5.135,
    r: 5.135,
    transform: "translate(873 576)",
    fill: "#bc002d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_839",
    "data-name": "Ellipse 839",
    transform: "translate(870 573)",
    fill: "none",
    stroke: "#f7f7f7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.135,
    cy: 8.135,
    r: 8.135,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.135,
    cy: 8.135,
    r: 7.635,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapaneseFlag);
export default __webpack_public_path__ + "static/media/japanese_flag.244dd5b82921d8b8cf172dbc10924a3e.svg";
export { ForwardRef as ReactComponent };